import { render, staticRenderFns } from "./darkmode.item.vue?vue&type=template&id=66dc25d1"
import script from "./darkmode.item.vue?vue&type=script&lang=js"
export * from "./darkmode.item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports